import { useEffect, useRef, useState } from 'react';
import { NotificationAlert, Table } from '../../../components';
import { allAnnualReviewsColumns } from './Columns';
import { getAllAnnualReviewCycles } from '../../../services/annualServices';
import { AnnualReviewCycle } from '../../../types/AnnualReview';

const AllAnnualReviewsMentor = () => {
  const [data, setData] = useState<AnnualReviewCycle[]>([]);
  const [loading, setLoading] = useState(true);
  const myRef = useRef<any>();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data, error } = await getAllAnnualReviewCycles('mentor');
      setLoading(false);
      if (error) return myRef.current?.call('error', error?.message);
      if (error) return;
      if (data) {
        setData(data);
      }
    })();
  }, []);

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="p-[10px] flex flex-col">
        <div className="text-[20px] font-[500]">All Annual Reviews</div>
        <div className="opacity-45">
          Effortlessly view and monitor existing annual review cycles, helping
          mentors stay informed about deadlines, statuses and overall feedback
          progress for their assigned mentees.
        </div>
      </div>
      <Table
        columns={allAnnualReviewsColumns}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey="id"
      />
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AllAnnualReviewsMentor;
